import { isMobile as mobileHelper } from 'src/utils/responsiveHelpers';
import { useState, useEffect } from 'react';

const useMobile = () => {
  const [isMobile, setIsMobile] = useState<boolean>(mobileHelper());
  const handleWindowSizeChange = () => {
    const isMob = mobileHelper();
    if (isMob !== isMobile) {
      setIsMobile(isMob);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, [handleWindowSizeChange]);

  return isMobile;
};

export default useMobile;
